import beursUitvraag from '../uitvraag.js';

const importInitieel = {

	init: function() {
		beursUitvraag.init();
	}

};

export default importInitieel;
